/**
 * Tuijn Code Export Backup Download Formatter.
 */
window.tuijncodeExportBackupDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/tuijncode/exports/backups/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
